<template>
  <div class="">
    <div>Browser articles by topic</div>

    <div class="mt-32 grid grid-cols-3 gap-32">
      <div
        v-for="i in 10"
        :key="i"
        class="bg-float-default-low h-56 w-full"
      ></div>
    </div>
  </div>
</template>
